import i18n from 'i18next';
import { useCallback } from 'react';
import { initReactI18next, useTranslation } from 'react-i18next';

import { translations } from './translations';

type TranslationLanguageKeys = 'en' | 'nb' | 'de' | 'cz' | 'fi' | 'sv';

export type Translation = {
  [key in TranslationLanguageKeys]: string;
};

function getTranslationLanguageKey(language: string): TranslationLanguageKeys {
  const baseLanguage = language.toLowerCase().split('-')[0];

  if (baseLanguage === 'cs') return 'cz';
  if (
    baseLanguage === 'en' ||
    baseLanguage === 'nb' ||
    baseLanguage === 'de' ||
    baseLanguage === 'cz' ||
    baseLanguage === 'fi' ||
    baseLanguage === 'sv'
  ) {
    return baseLanguage;
  }
  return 'en';
}

export function useTranslate() {
  const { t } = useTranslation('translation');
  const language = getTranslationLanguageKey(i18n.language);

  const translate = useCallback(
    (translation: Translation, interpolation?: { [key: string]: string | number }) => {
      const value = translation[language] || translation.en;
      return t('', { defaultValue: value, ...interpolation });
    },
    [language, t]
  );

  return { t: translations, translate };
}

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    debug: false,
    fallbackLng: 'en',
    resources: {
      translation: {
        en: {},
        nb: {},
        de: {},
        cs: {},
        cz: {},
        fi: {},
        sv: {},
      },
    },
  });
